import { TextField, FormControl } from "@mui/material";
import { useState, useEffect } from "react";
import { getInputLabelProps, getInputProps } from "../../../common/appStyles";
import { getEvidenceType } from "../../../common/EntitiesManagement";
import localize from "../../../common/localize";
import Combobox from "../../../components/common/Combobox";
import { MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION } from "../../../common/utils";

export default function AddEventReview({ model, setModel, evidences }) {
  const [descriptionCount, setDescriptionCount] = useState(0);
  const maximumCharactersForDescription = MAXIMUM_CHARACTERS_FOR_DESCRIPTION_OR_OBSERVATION;

  useEffect(() => {
    if (model.Observation) {
      setDescriptionCount(model.Observation.length);
    }
  }, [model?.Observation]);

  const handleEvidenceChange = (e) => {
    if (!e) {
      setModel({ ...model, Evidence: null, EvidenceId: 0 });
      return;
    }

    setModel({ ...model, Evidence: e, EvidenceId: e.Id });
  };

  const handleChange = (e) => {
    setModel({
      ...model,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div style={{ width: "100%" }} className="flex-col flex mt-2">
      <div className="w-full mb-4">
        <Combobox
          id="Evidence"
          handleValueChange={handleEvidenceChange}
          fieldLabel={localize.evidences}
          fieldOptions={evidences?.filter((x) => x.Available === 1) ?? []}
          fieldValue={model?.Evidence}
          customOptionLabel={(option) =>
            `${getEvidenceType(option.EvidenceType)} - ${option.Name}`
          }
        />
      </div>
      <div className="w-full mb-4">
        <TextField
          required
          InputLabelProps={getInputLabelProps()}
          inputProps={getInputProps()}
          size="small"
          fullWidth
          id="outlined-basic"
          name="Title"
          label={localize.title}
          variant="outlined"
          onChange={handleChange}
          value={model?.Name}
        />
      </div>
      <div className="w-full mb-6">
        <FormControl required fullWidth>
          <TextField
            InputLabelProps={getInputLabelProps()}
            inputProps={{
              style: {
                fontSize: "0.8em",
              },
              maxLength: maximumCharactersForDescription,
            }}
            size="small"
            fullWidth
            multiline
            rows={3}
            id="outlined-basic"
            name="Observation"
            label={localize.description}
            variant="outlined"
            onChange={handleChange}
            value={model.Description}
            helperText={`${descriptionCount}/${maximumCharactersForDescription}`}
          />
        </FormControl>
      </div>
    </div>
  );
}
